<template>
  <div>
    <div class="vx-row mt-4">
      <div
        v-for="(foto, index) in fotos"
        :key="foto.nomePosicao"
        class="vx-col sm:w-1/2 w-full mb-2"
      >
        <uploader
          :path="pathUpload"
          :label="foto.nomePosicao"
          :imageUrl="foto.nome"
          @uploaded="onUpload($event, index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import service from "../../../services";
import uploader from "./imageUploader";

export default {
  props: ["dadosAssociado", "fotosVeiculo"],
  watch: {
    fotosVeiculo(fotos) {
      this.fotosParaAtualizar = fotos;
    },
    dadosAssociado(associado) {
      this.idPessoa = associado.idProspect;
      this.buscaDados();
    }
  },
  components: { uploader },
  data() {
    return {
      idPessoa: null,
      fotos: [],
      fotosParaAtualizar: [],
      pathUpload: ""
    };
  },
  methods: {
    buscaDados() {
      if (!this.idPessoa) {
        return;
      }

      this.$vs.loading();

      const objSend = {
        idEvento: this.$route.params.idEvento,
        idPessoa: this.idPessoa,
        tipoPessoa: "Veiculo"
      };

      service
        .post("Eventos", "buscaFotosToUpload", objSend)
        .then(res => {
          if (!this.fotosParaAtualizar.length) {
            this.fotos = res.data;
          }
          this.$vs.loading.close();
        })
        .catch(e => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    onUpload(url, index) {
      const foto = this.fotos[index];
      foto.nome = url;

      const found = this.fotosParaAtualizar.find(
        f => f.nomePosicao === foto.nomePosicao
      );
      if (!found) {
        this.fotosParaAtualizar.push(foto);
      }

      this.$emit("formAlterado", this.fotosParaAtualizar);
    }
  },
  mounted() {
    this.pathUpload = `Eventos/${this.$route.params.idEvento}`;
    this.buscaDados();
  }
};
</script>
